// Dreams: what the user wants to have or experience, each with an optional photo; they make future
// pleasure feel real (INTENT.md, "Plan"). One Firestore document each, ordered by `sortOrder`
// (0 = matters most). Fears moved to src/features/statements/ when they gained categories and goals.
export const PLAN_ITEM_KINDS = {
  dreams: {
    collection: "dreams", title: "Dreamboard",
    one: "dream", many: "dreams", hueName: "red",
    intro: "These are the things you want to have or experience. Drag a dream with ⠿ to put the ones that matter most first.",
    empty: "Your Dreamboard is empty. Add something you want to have or experience, with a photo of it.",
    prompt: "What do you want to have or experience?",
  },
};

// The order a list shows in: by sortOrder, then oldest first for items that have none yet.
export const byPlanOrder = (a, b) =>
  (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity) || (a.createdMs ?? 0) - (b.createdMs ?? 0);

// A new item goes to the end of the list; the user drags it up if it matters more.
export const nextSortOrder = (items) =>
  items.reduce((max, it) => Math.max(max, Number.isFinite(it.sortOrder) ? it.sortOrder : -1), -1) + 1;
